export class L {
  getOptions() {
    return {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit'
    };
  }
}


/** WEBPACK FOOTER **
 ** ./~/eslint-loader!./src/core/i18n/date/MonthDayYearNumeric.js
 **/